// extracted by mini-css-extract-plugin
export var button = "_dp-0";
export var icon = "_dp-1";